import { UserCmsProfilePermissions } from 'services/user-cms-profile-permissions';

const API = 'Accounts';

export const API_AUTH = {
  GENERATE_PASSWORD: `${API}/GeneratePassword`,
  LOGIN: `${API}/LoginWithCode`,
  LOGOUT: `${API}/Logout`,
  REFRESH_TOKEN: `${API}/RefreshToken`,
  GET_CURRENT_USER: `${API}/GetCurrentAppUser`,
  PATCH_CURRENT_USER: `${API}/PatchCurrentUser`,
};

export interface CurrentAppUser {
  appUserID: string;
  email: string;
  isActive: true;
  languageID: string;
  name: string;
  userEmployeeProfilePermission: UserCmsProfilePermissions;
  userEmployeeProfileDepartmentID: string | null;
  userPhoto: string | null;
}

export interface JWT {
  jwt: {
    token: string;
    refreshToken: string;
  };
  expires: string;
}
